import React, { useState, useRef, useContext } from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import defaultProfilePic from '../../../assets/images/profilepic.png';
import '../../../assets/css/Customer/CustomerSettings/CustomerProfileSetting.css';
import CustomerSettingsMasterLayout from '../../../layouts/Customer/CustomerSettingsMasterLayout';
import axios from "axios";
import AppContext from "../../../context/AppContext";



const CustomerProfileSetting = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken } = useContext(AppContext);

  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    userName: '',
    mobileNumber: '',
    email: ''
  });

  const [profileImage, setProfileImage] = useState(defaultProfilePic);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Profile Updated:', formData);
    console.log('Profile Image:', profileImage);
    const data = new FormData();
    data.append('customerName', formData.userName);
    data.append('mobileNumber', formData.mobileNumber);
    data.append('customerEmail', formData.email); if (fileInputRef.current.files[0]) {
      data.append('customer_image', fileInputRef.current.files[0]);
    }

    axios
      .post(`${baseUrl}/customer/profile/updateProfile`, data, {
          headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${authToken}` }
        }).then(response => {
          if (response.data.success) {
            alert('Profile updated!');
          }
        }).catch(() => alert("Network Error!"));
  };
  // Image Upload Handler
  const handleImageEdit = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if file is an image
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setProfileImage(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert('Please select an image file');
      }
    }
  };

  return (
    <CustomerSettingsMasterLayout screenName={"CustomerProfileSetting"} centered={true}>
      <div className="CustomerProfileSetting-wrapper">
        <Container className="CustomerProfileSetting-container">
          {/* Profile Image Section */}
          <div className="CustomerProfileSetting-image-section">
            <div className="CustomerProfileSetting-image-wrapper">
              <img
                src={profileImage}
                alt="Profile"
                className="CustomerProfileSetting-image"
              />
              {/* Hidden File Input */}
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleImageChange}
                accept="image/*"
                style={{ display: 'none' }}
              />
              {/* Edit Button */}
              <Button
                variant="link"
                className="CustomerProfileSetting-edit-icon"
                onClick={handleImageEdit}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13" stroke="#2E2E2E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M16.04 3.02001L8.16 10.9C7.86 11.2 7.56 11.79 7.5 12.22L7.07 15.23C6.91 16.32 7.68 17.08 8.77 16.93L11.78 16.5C12.2 16.44 12.79 16.14 13.1 15.84L20.98 7.96001C22.34 6.60001 22.98 5.02001 20.98 3.02001C18.98 1.02001 17.4 1.66001 16.04 3.02001Z" stroke="#2E2E2E" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M14.91 4.15002C15.58 6.54002 17.45 8.41002 19.85 9.09002" stroke="#2E2E2E" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </Button>
            </div>
          </div>

          {/* Form Section */}
          <Form onSubmit={handleSubmit} className="CustomerProfileSetting-form">
            {/* User Name */}
            <Form.Group className="CustomerProfileSetting-form-group">
              <Form.Label className="CustomerProfileSetting-label">
                User Name
              </Form.Label>
              <Form.Control
                type="text"
                name="userName"
                placeholder="Enter your name"
                value={formData.userName}
                onChange={handleChange}
                required
                className="CustomerProfileSetting-input"
              />
            </Form.Group>

            {/* Mobile Number */}
            <Form.Group className="CustomerProfileSetting-form-group">
              <Form.Label className="CustomerProfileSetting-label">
                Mobile Number
              </Form.Label>
              <Form.Control
                type="tel"
                name="mobileNumber"
                placeholder="Enter your number"
                value={formData.mobileNumber}
                onChange={handleChange}
                required
                className="CustomerProfileSetting-input"
              />
            </Form.Group>

            {/* Email */}
            <Form.Group className="CustomerProfileSetting-form-group">
              <Form.Label className="CustomerProfileSetting-label">
                Email
              </Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
                className="CustomerProfileSetting-input"
              />
            </Form.Group>

            {/* Update Button */}
            <Button
              type="submit"
              className="CustomerProfileSetting-update-btn"
              onClick={handleSubmit}
            >
              Update
            </Button>
          </Form>
        </Container>
      </div>
    </CustomerSettingsMasterLayout>
  );
};


export default CustomerProfileSetting;